export default [
  {
    path: '/admin/website/template/Index',
    name: 'M020030',
    component: () => import('@/views/admin/website/template/Index.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/website/template/EditBaseInfo',
    name: 'website-template-index-templateIndex-edit-base-info',
    component: () => import('@/views/admin/website/template/EditBaseInfo.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/website/template/EditTemplate',
    name: 'website-template-index-templateIndex-edit-template',
    component: () => import('@/views/admin/website/template/EditTemplate.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/website/template/ChooseComponents',
    name: 'website-template-index-templateIndex-edit-template-chooseComponents',
    component: () =>
      import('@/views/admin/website/template/ChooseComponents.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/website/configuration/index',
    name: 'M020036',
    component: () => import('@/views/admin/website/configuration/Index.vue'),
    meta: {
      layout: 'admin',
      dataAuth: {
        bizCode: 'ow',
        operationCode: 'query',
      },
      targetName: '官网配置',
    },
  },
  {
    path: '/admin/website/configuration/GenerateEdit',
    name: 'website-configuration-generate-edit',
    component: () =>
      import('@/views/admin/website/configuration/GenerateEdit.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/website/configuration/ChooseTemplate',
    name: 'website-configuration-choose-template',
    component: () =>
      import('@/views/admin/website/configuration/ChooseTemplate.vue'),
    meta: { layout: 'admin' },
  },
];
